import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';

export const fetchAllContactUsMessagesRequest = createAction('fetchAllContactUsMessagesRequest');
export const fetchAllContactUsMessagesSuccess = createAction<ContactUsMessage[]>(
    'fetchAllContactUsMessagesSuccess',
);
export const fetchAllContactUsMessagesFailure = createAction('fetchAllContactUsMessagesFailure');

export const fetchAllContactUsMessages = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAllContactUsMessagesRequest());
    try {
        const { data }: Response = await api.get('admin/contactusmessages');
        dispatch(fetchAllContactUsMessagesSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAllContactUsMessagesFailure, e);
    }
};

interface Response {
    data: ContactUsMessage[];
}
